import { AP_API, API_V2 } from '@/infra/http';

import * as Types from './company.types';

export const getMinisiteOverview = async (webAddress = '', countryCode = 'cl', locationId?: string) =>
  AP_API.get<Types.MinisiteOverviewApiResponse>('/marketplace-minisite-bff/v1/minisite/overview', {
    params: { web_address: webAddress, country_code: countryCode, location_id: locationId },
  })
    .then((res) => res.data)
    .then(({ data, redirect }) => ({ ...data, logo: data.logo || '/assets/aProDefaultLogo.png', redirect }));

export const getCompanyBookingInfo = async (website = '', locale = 'cl') =>
  API_V2.get<Types.BookingInfoResponse>(`/companies/booking_info`, { params: { website, locale } }).then(
    (res) => res.data,
  );

export const getCompanyRRSS = (companyId?: number) =>
  API_V2.get<Types.RRSSResponse[]>('/social_networks', { params: { companyId } }).then((res) => {
    const filteredRRSS = res.data?.filter((item) => item.webAddress.trim());

    return filteredRRSS;
  });

export const checkWebAddressCountries = (
  webAddress: string,
  countryCode?: string,
): Promise<{
  countries: Types.CheckWebAddressCountriesResponse['data'];
  redirect?: Types.MarketplaceRedirect;
}> =>
  AP_API.get<Types.CheckWebAddressCountriesResponse>('/marketplace-minisite-bff/v1/minisite/countries', {
    params: { web_address: webAddress, country_code: countryCode },
  }).then((res) => ({ countries: res.data.data, redirect: res.data.redirect }));
